import React from 'react'
import GoogleMapReact from 'google-map-react'
import { Grid } from 'semantic-ui-react'

import { DistanceMarker } from 'components/Common/DistanceMarker'

import { DEFAULT_LOCATION_COORDINATE } from '@enlyt/base'
import { handleCall, handleDirectionByAddress } from 'helpers/linkingActions'

import { defaultStyles as styles } from '../styles'

const API_KEY = process.env.EH_GOOGLE_API_KEY_WEB_TEST

export const PracticeLocationsTab = ({ locations = [] }) => {
  return (
    <Grid style={styles.practiceLocationsContainer}>
      <Grid.Column
        mobile={16}
        tablet={16}
        computer={6}
        largeScreen={6}
        style={{ padding: 0 }}
      >
        {locations.items.length &&
          locations.items[0].map((location, i) => (
            <div
              key={i}
              style={{
                ...styles.location,
                ...(locations.items[0].length - 1 === i && { borderBottom: 0 })
              }}
            >
              <DistanceMarker distance={1} isPrimaryIcon />
              <div style={styles.locationInfoContainer}>
                <span style={styles.locationName}>{location.name}</span>
                <span style={styles.locationAddress}>{location.address}</span>
                <div>
                  <span
                    onClick={() => handleCall(location.phone)}
                    style={styles.locationPhone}
                  >
                    {`${location.phone} / `}
                  </span>
                  <span
                    onClick={() => handleDirectionByAddress(location.address)}
                    style={styles.locationPhone}
                  >
                    Get directions ›
                  </span>
                </div>
              </div>
            </div>
          ))}
      </Grid.Column>
      <Grid.Column
        mobile={16}
        tablet={16}
        computer={10}
        largeScreen={10}
        style={{ padding: 0, minHeight: 401 }}
      >
        {API_KEY ? (
          <GoogleMapReact
            bootstrapURLKeys={{ key: API_KEY }}
            center={DEFAULT_LOCATION_COORDINATE}
            defaultZoom={11}
            options={{
              fullscreenControl: false,
              zoomControl: false
            }}
          />
        ) : (
          <p style={styles.mapErrorText}>Map key must be defined</p>
        )}
      </Grid.Column>
    </Grid>
  )
}
